import React, { useRef, useState } from 'react';

export interface HoverState {
  visible: boolean;
  message: string;
  left: number;
  top: number;
}

export const useHoverTooltip = (defaultDelay = 50) => {
  const [hover, setHover] = useState<HoverState>({
    visible: false,
    message: '',
    left: 0,
    top: 0,
  });

  const timeoutRef = useRef<number | null>(null);

  const showHoverTooltip = (
    e: React.MouseEvent<HTMLElement>,
    message: string,
    delay = defaultDelay
  ) => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }
    const target = e.currentTarget as HTMLElement;
    timeoutRef.current = window.setTimeout(() => {
      const rect = target.getBoundingClientRect();
      setHover({
        visible: true,
        message,
        left: rect.left + rect.width / 2,
        top: rect.top - 8,
      });
    }, delay) as unknown as number;
  };

  const hideHoverTooltip = () => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    setHover((s) => ({ ...s, visible: false }));
  };

  return { hover, showHoverTooltip, hideHoverTooltip } as const;
};
